import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/Book.css";

/*
  Book Page

  Purpose:
  Presents the booking experience inside a styled card
  while isolating third party code inside an iframe.

  Height Handling:
  - The iframe posts its content height via postMessage
  - React listens and resizes the iframe only
  - No window resize listeners are used
*/

export default function Book() {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(900);


  useEffect(() => {
    document.body.classList.add("route-book");

    return () => {
      document.body.classList.remove("route-book");
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type !== "BOOKAPP_HEIGHT") return;

      if (typeof event.data.height === "number") {
        setIframeHeight(event.data.height);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <main className="booking-container">
      <Helmet>
        <title>Schedule Your Visit | Lash With Brittany</title>
        <meta
          name="description"
          content="Schedule your lash or permanent jewelry appointment online with ease. Choose your service, view availability, and reserve your time."
        />
        <link rel="canonical" href="https://lashwithbrittany.com/book" />
      </Helmet>

      <section className="booking-intro">
        <h1>Schedule Your Lash and Beauty Appointment</h1>


        <p className="booking-subtitle">
          Select your service and reserve your time
        </p>

        <p className="booking-description">
          Booking is quick and easy. Choose the service that best fits your
          needs, review details and availability, and confirm your appointment.
        </p>

        <p className="booking-helper">
          Not sure which service to choose? Select the option that best matches
          what you are looking for. Adjustments can always be made during your
          appointment.
        </p>
      </section>

      <div className="booking-widget-shell">
        <div className="booking-card">
          <iframe
            ref={iframeRef}
            src="/book-embed.html"
            title="Book Appointment"
            className="booking-iframe"
            style={{ height: iframeHeight }}
            scrolling="no"
          />
        </div>
      </div>
    </main>
  );
}
